import PageMain from './components/PageMain.vue'
import PageAbout from './components/PageAbout.vue'
import PageOffers from './components/PageOffers.vue'
import PageContact from './components/PageContact.vue'
import PageCareer from './components/PageCareer.vue'
import PagePP from './components/PagePP.vue'

export default [
  {
    path: '/',
    component: PageMain,
    meta: {
      title: 'Usługi logistyczne - Obsługa programu SAP - Sprawdź naszą ofertę',
      metaTags: [
        {
          name: 'description',
          content: 'Świadczymy usługi logistyczne i około transportowe 🚜, nasi pracownicy posiadają długoletnie doświadczenie w obsłudze programu SAP oraz jesteśmy firmą znaną na lokalnym rynku. Polecamy naszą szeroką ofertę usług takich jak: magazynowanie 📦, sortowanie opakowań zwrotnych, prace administracyjne, kontrola jakości produkcji piwa oraz przewóz opakowań. Pracujemy w branży transportu lądowego i handlingu 🏗️.'
        }
      ]
    }
  },
  {
    path: '/o-firmie',
    component: PageAbout,
    meta: {
      title: 'Świadczymy usługi logistyczne - Doświadczona kadra - Zobacz więcej',
      metaTags: [
        {
          name: 'description',
          content: 'Stabilna i wiarygodna firma świadcząca usługi logistyczne i handlingowe. Lider zatrudnienia na rynku lokalnym. Posiadamy wieloletnie doświadczenie w branży specjalizującej się w obsłudze programu SAP 💻 i metodach efektywnego magazynowania 📦.'
        }
      ]
    }
  },
  {
    path: '/oferta',
    component: PageOffers,
    meta: {
      title: 'Najwyższa jakość usług - Obsługa wózków widłowych - Sprawdź ofertę',
      metaTags: [
        {
          name: 'description',
          content: 'Usług o charakterze gospodarczym i administracyjnym. Posiadamy zaplecze w wózków widłowych i sprzętu służącego do efektywnego magazynowania . Zatrudniamy wykwalifikowanych pracowników administracyjnych i operatorów wózków widłowych 👷‍♂️. W ofercie mamy, także porządkowanie powierzchni magazynowej, przepakowywanie i kontrola produktów 🏭.'
        }
      ]
    }
  },
  {
    path: '/kontakt',
    component: PageContact,
    meta: {
      title: 'Dane adresowe firmy - Formularz kontaktowy - Napisz do nas',
    }
  },
  {
    path: '/kariera',
    component: PageCareer,
    meta: {
      title: 'Doświadczona kadra - Oferty pracy - Pracuj z najlepszymi',
    }
  },
  {
    path: '/polityka-prywatnosci',
    component: PagePP
  }
]
